import { ELanguage } from '@/types';

type TLanguageOptions = {
  id: ELanguage;
  image: string;
};

export const languageOptions: TLanguageOptions[] = [
  { id: ELanguage.EN, image: '/images/countries/us.png' },
  { id: ELanguage.ES, image: '/images/countries/es.png' },
  { id: ELanguage.PT, image: '/images/countries/br.png' },
];

/**
 * Returns the list of language options with translated titles.
 * @param t - Translation function for converting language IDs into localized strings.
 * @returns Array of language options including translated titles.
 */
export const translatedLanguageOptions = (t: (value: string) => string) => {
  return languageOptions.map((option) => ({
    ...option,
    title: t(`languages.${option.id}`),
  }));
};
